import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function SecurityPolicy() {
  return (
    <PolicyPage title="Responsible Disclosure Policy">
      <h2>Reporting a security issue</h2>
      <p>We welcome good-faith reports that help protect customers and the store. Email <ContactEmail /> with "Security Report" in the subject line and include the affected page, steps to reproduce, potential impact, and any safe supporting evidence.</p>

      <h2>Safe research guidelines</h2>
      <ul>
        <li>Use only accounts and data you own or have explicit permission to test.</li>
        <li>Minimize access, stop when sensitive data is encountered, and do not retain or disclose it.</li>
        <li>Do not use denial-of-service, destructive testing, malware, automated high-volume scanning, spam, or social engineering.</li>
        <li>Do not change orders, payments, fulfilment records, or another person's data.</li>
        <li>Give us reasonable time to investigate before any public disclosure.</li>
      </ul>

      <h2>Our response</h2>
      <p>We aim to acknowledge a useful report, assess severity, and keep the reporter informed when practical. Time to resolution depends on complexity and third-party involvement. This policy does not create a promise of payment or a bug-bounty program.</p>

      <h2>Good-faith reports</h2>
      <p>Where permitted by law, we do not intend to pursue action against research that follows this policy, avoids privacy harm and disruption, and is reported promptly. This statement cannot authorize testing of third-party systems or conduct prohibited by law.</p>

      <h2>Customer account concerns</h2>
      <p>For suspected payment fraud or unauthorized account activity, contact us promptly and also notify your payment provider. Do not include passwords or complete card numbers in email.</p>
    </PolicyPage>
  );
}

export default SecurityPolicy;
